import { createRouter, createWebHistory } from 'vue-router';
import { ROUTES } from './routes';
import login from './router-hooks/login-hook';
import report from './router-hooks/report-hook';
import branchTest from './router-hooks/branch-test-hook';

const router = createRouter({
  history: createWebHistory(),
  routes: ROUTES,
});
// 新用户登录流程先登录再邀请码再填信息
router.beforeEach(login);
// 根据路由跳转进行main页面的数据上报
router.beforeEach(report);
// 自动携带分支测试参数，只在测试环境开启
if (import.meta.env.MODE === 'test') {
  router.beforeEach(branchTest);
}

export default router;
